import { type JobStatus } from '@/features/jobs/job-status'
import { match } from '@/utils/pattern-match-util'

/**
 * The job history label of a job status.
 */
export function jobStatusLabel(status: JobStatus): string {
  return match(status, {
    UnderConstruction: () => 'Under Construction',
    InfoGathering: () => 'Info Gathering',
    Unclaimed: () => 'Unclaimed',
    Claimed: () => 'Claimed',
    OnHold: () => 'On Hold',
    Idle: () => 'Idle',
    Closed: () => 'Closed',
    Pending: () => 'Pending',
  })
}
